"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LatitudeBand = void 0;
const MGRSUtils_1 = require("../MGRSUtils");
/**
 * Latitude (horizontal) band
 */
class LatitudeBand {
    /**
     * Constructor
     *
     * @param letter
     *            band letter
     * @param south
     *            southern latitude
     * @param north
     *            northern latitude
     */
    constructor(letter, south, north) {
        this.letter = letter;
        this.hemisphere = MGRSUtils_1.MGRSUtils.getHemisphere(letter);
        this.south = south;
        this.north = north;
    }
    /**
     * Get the band letter
     *
     * @return band letter
     */
    getLetter() {
        return this.letter;
    }
    /**
     * Set the band letter
     *
     * @param letter
     *            band letter
     */
    setLetter(letter) {
        this.letter = letter;
        this.hemisphere = MGRSUtils_1.MGRSUtils.getHemisphere(letter);
    }
    /**
     * Get the southern latitude
     *
     * @return southern latitude
     */
    getSouth() {
        return this.south;
    }
    /**
     * Set the southern latitude
     *
     * @param south
     *            southern latitude
     */
    setSouth(south) {
        this.south = south;
    }
    /**
     * Get the northern latitude
     *
     * @return northern latitude
     */
    getNorth() {
        return this.north;
    }
    /**
     * Set the northern latitude
     *
     * @param north
     *            northern latitude
     */
    setNorth(north) {
        this.north = north;
    }
    /**
     * Get the hemisphere
     *
     * @return hemisphere
     */
    getHemisphere() {
        return this.hemisphere;
    }
}
exports.LatitudeBand = LatitudeBand;
//# sourceMappingURL=LatitudeBand.js.map